









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class MaybeLink extends Vue {
  @Prop({ required: true })
  href: string | null
}
